import React from 'react';

import { RepeatComponent } from 'app/component/repeat-component/RepeatComponent';
import { FlexibleSkeleton } from 'app/component/skeleton/flexible/FlexibleSkeleton';
import { PlateSkeleton } from 'app/component/skeleton/plate/PlateSkeleton';
import { SubmitSkeleton } from 'app/component/skeleton/submit/SubmitSkeleton';
import { useIsDesktop, useWindowType } from 'app/utils/useWindowType';

export const DraftSkeleton = () => {
    const [windowType] = useWindowType();
    const [isDesktop] = useIsDesktop();

    return (
        <>
            <div style={{ height: 72 }}>
                <FlexibleSkeleton windowType={windowType} />
            </div>
            {!isDesktop && (
                <div style={{ marginTop: 24 }}>
                    <PlateSkeleton windowType={windowType} />
                </div>
            )}
            <div style={{ marginTop: 48 }}>
                <RepeatComponent numberRepetitions={2}>
                    <div style={{ marginTop: 24 }}>
                        <PlateSkeleton windowType={windowType} />
                    </div>
                </RepeatComponent>
            </div>
            <div
                style={{
                    marginTop: 48,
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <SubmitSkeleton windowType={windowType} />
                <SubmitSkeleton windowType={windowType} />
            </div>
        </>
    );
};
